import {useEffect, useState} from 'react';
import {useDispatch, useSelector, useStore} from 'react-redux';
import {authAnimation} from '../../animations';
import {motion, AnimatePresence} from 'framer-motion'
import saveProspectus from '../../actions/saveProspectus';

import {useHistory} from 'react-router-dom';

const SaveOrLoad = () => {

    const store = useStore().getState();
    const history = useHistory();

    const [saveText, setSaveText] = useState('Save');
    const [loadText, setLoadText] = useState('Load');

    const dispatch = useDispatch();
    const {user, saved} = useSelector((state) => state.user)
    const {inActiveCourses, activeCourses} = useSelector((state) => state.prospectus)

    /**
     * User clicked the save button, fire the action &&
     * set a loading text on the button.
     */
    const handleSave = (evt) => {
        evt.preventDefault();

        setSaveText( 'loading...' );

        // Save the prospectus.
        dispatch(saveProspectus(store.prospectus, user.jwtAuthToken));
    }

    /**
     * Load the users prospectus.
     */
    const handleLoad = () => {

        // Set text to show something is happening.
        setLoadText( 'Loading...' );

        // They do have a prospectus.
        if ( user.userProspectus ) {
            // Close the sidebar
            dispatch({ type : 'CLOSE_SIDEBAR' });

            // Reset the button text.
            setLoadText( 'Load' );

            // Navigate to the prospectus url to output the loaded prospectus.
            history.push('/prospectus/' + user.userProspectus);
        }
    }

    /**
     * When the saved state changes toggle the loading visuals.
     */
    useEffect(() => {

        if ( saved ) {
            setSaveText( 'save' );

            setTimeout(() => {
                dispatch({ type: 'HIDE_SAVED' })
            }, 3000);
        }

    }, [saved]);

    return(
        <AnimatePresence exitBeforeEnter>
            <motion.div
                variants={authAnimation}
                initial="initial"
                animate="visible"
                exit="exit"
                layoutId="share"
                key="loginShare"
            >

            {
                !user.userProspectus && ! ( inActiveCourses.length > 0 || activeCourses.length > 0 ) ? (
                    <div>
                        <h3>Start your journey</h3>
                        <p>Now that you've signed up, you can venture through the prospectus, save, and share it with friends and family</p>
                    </div>
                ): ''
            }

            {
                // If we have started a prospectus && also have one saved.
                user.userProspectus && ( inActiveCourses.length > 0 || activeCourses.length > 0 ) ? (
                    <div>
                        <h3>Would you like to save or load?</h3>
                        <p>We can see that there is already a save file associated with this email address. Would you like to load that or save and overwrite what currently exists?</p>
                    </div>
                ) : ''
            }

            {
                // If we have started a prospectus, but have nothing to load.
                ! user.userProspectus && ( inActiveCourses.length > 0 || activeCourses.length > 0 ) &&
                <div>
                    <h3>Would you like to save?</h3>
                    <p>Saving your prospectus allows you to share with friends and family or return at a later date and make changes</p>
                </div>
            }

            {
                // If we have a prospectus, but have nothing to save.
                user.userProspectus && ! ( inActiveCourses.length > 0 || activeCourses.length > 0 ) &&
                <div>
                    <h3>Would you like to load?</h3>
                    <p>We can see that there is already a save file associated with this email address. Would you like to load it?</p>
                </div>
            }

            {
                // If we have started a prospectus, then allow the user to save it.
                ( inActiveCourses.length > 0 || activeCourses.length > 0 ) &&
                <div>
                    <div className="errors">
                        {saved ? (
                            <div className="alert success">Prospectus saved</div>
                        ) : ''}
                    </div>

                    <button className="button outline" onClick={handleSave}>{saveText}</button>
                </div>
            }

            {
                user.userProspectus && ( inActiveCourses.length > 0 || activeCourses.length > 0 ) &&
                <div className="text-center">
                    <p>Or</p>
                </div>
            }

            {
                // If we have a saved prospectus, then the user load it.
                user.userProspectus &&
                <button className="button login" onClick={handleLoad}>{loadText}</button>
            }
            </motion.div>
        </AnimatePresence>
    )
}
export default SaveOrLoad;